import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { AnnouncementsBannerService } from './announcements-banner.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'ag-announcements-banner',
  templateUrl: './announcements-banner.component.html',
  styleUrl: './announcements-banner.component.scss',
})
export class AnnouncementsBannerComponent implements OnInit {
  private _bannerService = inject(AnnouncementsBannerService);
  private _router = inject(Router);
  private _destroyed$ = new Subject<void>();

  private readonly _allowedPaths = ['dashboard', 'request-manager'];

  readonly announcements$ = this._bannerService.announcements$;
  show = false;

  ngOnInit(): void {
    this._bannerService.load();
    this._updateShow(this._router.url);
    this._router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this._destroyed$),
      )
      .subscribe((e) => this._updateShow(e.urlAfterRedirects));
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  private _updateShow(url: string): void {
    this.show = this._allowedPaths.some((p) => url.includes(p));
  }
}
